import { render, staticRenderFns } from "./UserPreferenceSettings.vue?vue&type=template&id=020e659c&scoped=true"
import script from "./UserPreferenceSettings.vue?vue&type=script&lang=ts"
export * from "./UserPreferenceSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e659c",
  null
  
)

export default component.exports